import React, { useEffect, useState, useMemo, useContext } from "react";
import { Modal, Checkbox, Input, Divider } from "antd";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import defaultLogo from "../../assets/images/default_company_logo.jpg";
import { getSubscriptionUserInfo, getUserInfo } from "../../utils/utils";
import TrialModal from "../../common/TrialModal";
import popupImg from "../../assets/images/free-user-login-prompt.jpg.jpeg";
import {
  submitErrorForm,
  postRelavantCompany,
  getRelavantCompany,
  resetPostRelavantCompany,
  updateRelavantCompany,
} from "../../actionCreator/companyDetailsActionCreator";
import { emailRegex } from "../../config";
import { AuthContext } from "../../context/AuthContext";

const SimilarCompany = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [similarCount, setSimilarCount] = useState(5);
  const [openErrorForm, setOpenErrorForm] = useState(false);
  const [checkCompanyStatus, setCheckCompanyStatus] = useState(0);
  const formIntialValue = {
    telephone: { disabled: true, value: "", status: null },
    address: { disabled: true, value: "", status: null },
    city: { disabled: true, value: "", status: null },
    zip: { disabled: true, value: "", status: null },
    employee: { disabled: true, value: "", status: null },
    website: { disabled: true, value: "", status: null },
    name: { disabled: true, value: "", status: null },
    email: { disabled: true, value: "", status: null },
    comment: { disabled: true, value: "", status: null },
  };
  const { TextArea } = Input;
  const [errorForm, setErrorForm] = useState(formIntialValue);
  const companyDetails = useSelector(
    (state) => state.companyDetailsReducer.companyDetails
  );
  const similarCompanyList = useSelector(
    (state) => state.companyDetailsReducer.similarCompanyList
  );
  const getRelavantCompanyDetails = useSelector(
    (state) => state.companyDetailsReducer.getRelavantCompany
  );

  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo
  );

  useEffect(() => {
    const [data] = getRelavantCompanyDetails || [];
    if (data) {
      setCheckCompanyStatus(data?.prescribedby === "True" ? 1 : 2);
    }
  }, [getRelavantCompanyDetails]);

  useMemo(() => {
    dispatch(resetPostRelavantCompany);
    if (Object.keys(getUserInfo()).length && companyDetails?.id) {
      const { id } = getUserInfo();
      dispatch(getRelavantCompany(id, companyDetails?.id));
    }
  }, [userAccountInfo, companyDetails]);

  useEffect(() => {
    setSimilarCount(
      similarCompanyList.length < 5 ? similarCompanyList.length : 5
    );
  }, [similarCompanyList]);

  const getDetails = (id, name) => {
    let cname = name.replaceAll(" ", "-").toLowerCase();
    navigate(`/company-summary/${id}/${cname}`);
  };

  const renderSimilarCompanyList = () => {
    let similarList = [];
    for (let i = 0; i < similarCount; i++) {
      similarList.push(
        <div
          key={`similarCompany_${i}`}
          className="similarinnerblk company-card"
        >
          <div className="img-responsive">
            <img
              alt="Company Logo"
              src={similarCompanyList[i]?.companyLogoUrl || defaultLogo}
              onError={(e) => {
                e.currentTarget.src = defaultLogo;
              }}
              className="company-logo"
            />
          </div>
          <div className="similar-desc">
            <a
              href={`/company/${similarCompanyList[i]?.id}`}
              onClick={(e) => {
                e.preventDefault(); // Prevent default navigation if needed
                getDetails(
                  similarCompanyList[i]?.id,
                  similarCompanyList[i]?.name
                );
              }}
              className="font-weight-bold heading13px text-black"
              title={`${similarCompanyList[i]?.name}`}
            >
              {similarCompanyList[i]?.name}
            </a>

            <div className="fs-13">{similarCompanyList[i]?.industry?.name}</div>
            <div className="fs-13 mb10" style={{ marginTop: "5px" }}>
              {similarCompanyList[i]?.address}
            </div>
          </div>
        </div>
      );
    }
    if (!similarList.length) {
      similarList.push(
        <div className="similarinnerblk">
          <div className="s-company img-responsive">
            <img src={defaultLogo} alt="" />
          </div>
          <div className="similar-desc">
            <div className="font-weight-bold fs-14">
              No similar company found.
            </div>
          </div>
        </div>
      );
    }
    return similarList;
  };

  const getMoreSimilarCount = () => {
    if (similarCount === 5) {
      setSimilarCount(10);
    } else {
      setSimilarCount(5);
    }
  };

  const checkRelavantCompany = (flag, thumbStatus) => {
    //checkCompanyStatus
    const isLoggedIn = checkLoginStatus();
    if (isLoggedIn) {
      const [data] = getRelavantCompanyDetails || [];

      const { id } = getUserInfo();
      const { id: accountId } = getSubscriptionUserInfo();
      if (data?.id) {
        //update case
        let payload = {
          id: data?.id,
          accountId: accountId,
          companyId: companyDetails?.id,
          iscompany: true,
          prescribedby: flag ? "True" : "False",
          userId: id,
        };
        dispatch(updateRelavantCompany(payload));
      } else {
        let payload = {
          accountId: accountId,
          companyId: companyDetails?.id,
          iscompany: true,
          prescribedby: flag ? "True" : "False",
          userId: id,
        };
        dispatch(postRelavantCompany(payload));
      }
    }
  };
  const checkLoginStatus = () => {
    let isLoggedIn = false;
    if (isAuthenticated) {
      setShowModal(false);
      isLoggedIn = true;
    } else {
      setShowModal(true);
      isLoggedIn = false;
    }
    return isLoggedIn;
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const redirectToSignup = () => {
    setShowModal(false);
    navigate("/signup");
  };

  const handleErrorForm = () => {
    setOpenErrorForm(true);
  };

  const closeErrorForm = () => {
    setOpenErrorForm(false);
    setErrorForm(formIntialValue);
  };

  const enableField = (ele) => {
    setErrorForm({
      ...errorForm,
      [ele.target.name]: ele.target.checked
        ? { ...errorForm[ele.target.name], disabled: !ele.target.checked }
        : { value: "", disabled: !ele.target.checked },
    });
  };

  const onSubmitForm = () => {
    const regEx = new RegExp(emailRegex);
    const clone = _.cloneDeep(errorForm);
    if (!errorForm?.name?.value) {
      clone.name.status = "error";
      setErrorForm(clone);
      return false;
    }

    if (!errorForm?.email?.value || !regEx.test(errorForm?.email?.value)) {
      clone.email.status = "error";
      setErrorForm(clone);
      return false;
    }


    let newPayload = {};
    Object.keys(errorForm).forEach((key) => {
      newPayload = {
        ...newPayload,
        [key]: errorForm[key].value,
      };
    });
    const { id } = getUserInfo();
    const { id: accountId } = getSubscriptionUserInfo();
    const payload = {
      accountId: accountId,
      companyId: companyDetails?.id,
      description: JSON.stringify(newPayload),
      iscompany: true,
      iscorrected: true,
      userId: id,
    };
    // errorForm
    dispatch(submitErrorForm(payload));
    setOpenErrorForm(false);
    setErrorForm(formIntialValue);
  };

  const onInputChange = (ele) => {
    setErrorForm({
      ...errorForm,
      [ele.target.name]: {
        ...errorForm[ele.target.name],
        value: ele.target.value,
        status: null,
      },
    });
  };
  return (
    <>
      {renderSimilarCompanyList()?.length ? (
        <div className="common-box-2 p-0 mb-4">
          <h3 className="heading18px fw-bold px-20 py-10 _border-bottom">
            Similar Companies
          </h3>
          <div className="similarblk max-h-58vh d-flex flex-column gap-20 p-20">
            {renderSimilarCompanyList()}
            <div>
              {similarCompanyList?.length > 5 && (
                <div
                  className="fs-13 text-center text-theme cursor-pointer"
                  onClick={getMoreSimilarCount}
                >
                  {similarCount === 10 ? "Show Less" : "Show More"}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="common-box-2 descbox1">
        <div className="fs-13 d-flex align-items-center gap-10 justify-content-center">
          Is this company data relevant to you?{" "}
          {checkCompanyStatus === 1 ? (
            <span>
              <i className="right-icons fa fa-thumbs-up" aria-hidden="true"></i>
            </span>
          ) : (
            <span onClick={() => checkRelavantCompany(1, checkCompanyStatus)}>
              <i
                className="right-icons small fa fa-thumbs-up"
                aria-hidden="true"
              ></i>
            </span>
          )}
          {checkCompanyStatus === 2 ? (
            <span>
              <i
                className="right-icons fa fa-thumbs-down"
                aria-hidden="true"
              ></i>
            </span>
          ) : (
            <span onClick={() => checkRelavantCompany(0, checkCompanyStatus)}>
              <i
                className="right-icons small fa fa-thumbs-down"
                aria-hidden="true"
              ></i>
            </span>
          )}
        </div>
      </div>
      <div className="buttons-container">
        <div
          className="fw-bold border-theme p5px gap-10 d-flex align-items-center justify-content-center rounded-lg cursor-pointer text-theme fs-13 w-99 mt-3 pr-2 "
          onClick={handleErrorForm}
        >
          <i className="right-icons fs-10 las la-flag" aria-hidden="true"></i>
          Report An Error
        </div>
      </div>

      {openErrorForm && (
        <Modal
          title={
            <div className="errorformcontainertitle">
              <h4>Report an Error</h4>
              <h2>Report Incorrect Information</h2>
            </div>
          }
          okText="Submit"
          cancelText="Cancel"
          width="450px"
          open={openErrorForm}
          onOk={onSubmitForm}
          onCancel={closeErrorForm}
        >
          <div className="errorformcontainer">
            <p>
              Please select the appropriate checkbox that you have found
              Incorrect and if you know the correct data please provide us in
              appropriate text box.
            </p>
            <div className="form">
              <div className="formcol1">
                <Checkbox name="telephone" onChange={enableField}>
                  Telephone
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="telephone"
                  value={errorForm?.telephone?.value}
                  placeholder="Telephone"
                  disabled={errorForm?.telephone?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="address" onChange={enableField}>
                  Address
                </Checkbox>
              </div>
              <div className="formcol2">
                <TextArea
                  name="address"
                  value={errorForm?.address?.value}
                  rows={2}
                  maxLength={100}
                  disabled={errorForm?.address?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="city" onChange={enableField}>
                  City
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="city"
                  value={errorForm?.city?.value}
                  placeholder="City"
                  disabled={errorForm?.city?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="zip" onChange={enableField}>
                  Zip/Pin code
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="zip"
                  value={errorForm?.zip?.value}
                  placeholder="Zip/Pin code"
                  disabled={errorForm?.zip?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="employee" onChange={enableField}>
                  No. of Employees
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="employee"
                  value={errorForm?.employee?.value}
                  placeholder="No. of Employees"
                  disabled={errorForm?.employee?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="website" onChange={enableField}>
                  Website
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="website"
                  value={errorForm?.website?.value}
                  placeholder="Website"
                  disabled={errorForm?.website?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <Divider dashed={true} />

            <div className="formfull">
              <Input
                name="name"
                status={errorForm?.name?.status}
                value={errorForm?.name?.value}
                placeholder="Your Name*"
                onChange={onInputChange}
              />
            </div>

            <div className="formfull">
              <Input
                name="email"
                status={errorForm?.email?.status}
                value={errorForm?.email?.value}
                placeholder="Your Email ID*"
                onChange={onInputChange}
              />
            </div>

            <div className="formfull">
              <TextArea
                name="comment"
                value={errorForm?.comment?.value}
                rows={3}
                maxLength={100}
                placeholder="Comment if any"
                onChange={onInputChange}
              />
            </div>
          </div>
        </Modal>
      )}

      {showModal ? (
        <TrialModal
          openModal={showModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
          buttonText="Start Free Trial"
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={popupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                Get 10 free verified contacts with a BeyondLeadz Pro trial
              </p>
              <p>
                BeyondLeadz Pro customers close deals faster thanks to relevant
              </p>
            </div>
          }
          modalWidth="400px"
        />
      ) : (
        ""
      )}
    </>
  );
};

export default SimilarCompany;
